import {connect} from 'react-redux'
import React, {Component} from 'react';
import ReportGeneralTable from './ReportGeneralTable'
import {Breadcrumb} from 'react-bootstrap'
import PriceCompareDoc from '../pricecompare/PriceCompareDoc'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome'
import Moment from 'moment'
class ReportPriceComparePage extends Component {

  constructor(...args){
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    const optionsMonth = [
      { value: 0, label: this.props.messages['All Year'] },
      { value: '01', label: this.props.messages['January'] },
      { value: '02', label: this.props.messages['February'] },
      { value: '03', label: this.props.messages['March'] },
      { value: '04', label: this.props.messages['April'] },
      { value: '05', label: this.props.messages['May'] },
      { value: '06', label: this.props.messages['June'] },
      { value: '07', label: this.props.messages['July'] },
      { value: '08', label: this.props.messages['August'] },
      { value: '09', label: this.props.messages['September'] },
      { value: '10', label: this.props.messages['October'] },
      { value: '11', label: this.props.messages['November'] },
      { value: '12', label: this.props.messages['December'] }
    ];

    this.state = {
      showTable: true,
      data: [],
      length: 10,
      totalPage: 0,
      loading: false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      defaultMonth: 0,
      defaultYear: yTh,
      type: 'tool',
      record_type: 'request_purchase',
      pricecompare_no:''
    }
    this.poTable = null
  }

  componentDidMount() {
    
  }

  loadData(year,month,day,searchBy,query,year_series,activePage,itemPerPage,callback){
    ReportStore.loadPriceCompareList(year,month,day,searchBy,query,year_series,activePage*itemPerPage,itemPerPage,callback)
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  // renameDoc(newPoNo){
  //   this.refs.poDoc.getWrappedInstance().renameDoc(newPoNo)
  // }

  showTable(){
    this.setState({showTable:true})
    if(this.poTable!==null)
      this.poTable.refreshTable() 
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    this.setState({showTable:false,pricecompare_no:item.pricecompare_no})
    this.refs.poDoc.loadPriceCompare(item.pricecompare_no)
    if(this.props.onDocShow!==undefined){
      this.props.onDocShow(item.pricecompare_no)
    }
  }

  onDocNew(){
    this.setState({showTable:false})
    let that = this
    this.refs.poDoc.loadNewPriceCompare(function(item){
      that.setState({pricecompare_no:item.pricecompare_no})
      if(that.props.onDocShow!==undefined){
        that.props.onDocShow(item.pricecompare_no)
      }
    })    
  }

  renderStatus(status,row){
    let result = (<span></span>)
    let {messages} = this.props
    if (row.status==0) {
      result = (<span className="label label-default" data-value="0">{messages['Start']}</span>)
    }else if (row.status==1) {
      result = (<span className="label label-primary" data-value="1">{messages['Approved']}</span>)
    } else if (row.status==2) {
      result = (<span className="label label-primary" data-value="2">{messages['Received']}</span>)
    } else if (row.status==3) {
      result = (<span className="label label-success" data-value="3">{messages['Imported']}</span>)
    } else if (row.status==4) {
      result = (<span className="label label-success" data-value="4">{messages['Repaired']}</span>)  
    } else{
      result = (<span></span>)
    }

    return result
  }

  renderDetail(data,row) {
    if (row.detaillist) {
      let arr = []
      arr = row.detaillist.split(',')
      return(
        arr.map((item,index)=>{
          return <div key={'part-detail-'+index}>{index+1}. {item}</div>
        })
      )
    }
    return
  }

  onRenderColumn(data,col,row){ 
    if(col===9){ 
      return this.renderStatus(data,row)     
    } else if (col===7) {
      return (<span style={{color:(data<0?'red':'')}}>{data}</span>)
    } else if (col===4) {
      return this.renderDetail(data,row)
    } else if (col===5) {
      return (<span className='pull-left'>{row.brand_model}</span>)
    } else if (col===6) {
      return (<span>{row.year_series}</span>)
    } else{ 
      return (<span>{data}</span>)
    }
  }

  onDocClose(){
    this.setState({pricecompare_no:''})
    this.showTable() 
  }


  renderCustomFooter(headerTitles,e) {
    let {messages} = this.props
    let sum = 0
    e.forEach(function(item,index) {
      let amount = item.amount
      if (amount===''||amount===null||amount===undefined||isNaN(amount))
        amount = 0

      sum += parseFloat(amount)
    })
    return(
      <tfoot>
        <tr>
        {
          headerTitles.map((item,index)=>{
            return(
              <th className={item.title==='มูลค่า(บาท)'?'text-right':'text-center'} key={index}>{item.title==='มูลค่า(บาท)'?messages['Sum']+' '+this.getNumberFormat(sum):item.title}</th>
            )
          })
        }
        </tr>
      </tfoot>  
    )
  }

  render(){
    let {showTable} = this.state
    let {messages} = this.props
    const headerTitles = [
      {title:messages['Date'],width:'100px'},
      // {title:messages['Document number'],width:'120px'},
      {title:messages['Parts list'],width:'150px'},
      // {title:messages['Brand/Model'],width:'150px'},
      // {title:messages['Year series'],width:'100px'},
      {title:messages['Value'],width:'150px'},
      {title:messages['Remark'],width:'200px'}  
    ]
    const searchOptions = [
      {
        label: messages['Products list'],
        value: 'part_name'
      },
      // {
      //   label: messages['Brand/Model'],
      //   value: 'brand_model'
      // }   
    ]
    return (
          <div>
              <div style={{display:showTable?'block':'none'}}>
                <ReportGeneralTable 
                  onRef={(ref)=>{this.poTable = ref}}
                  show={true}
                  title={messages['Title']} 
                  headerTitles={headerTitles}
                  searchOptions={searchOptions}
                  searchBy={'part_name'}
                  excludeColumn={['pricecompare_no','year_series','brand_model','request_by','department','status']}
                  loadData={this.loadData.bind(this)}
                  onRowSelect={this.onRowSelect.bind(this)} 
                  onDocNew={this.onDocNew.bind(this)}
                  onRenderColumn={this.onRenderColumn.bind(this)}
                  customFooter={true}
                  renderCustomFooter={this.renderCustomFooter.bind(this,headerTitles)}
                  minWidth={'1300'}
                  docType='partpricecompare'
                />
              </div>  
              <div style={{display:!showTable?'block':'none'}}>
                <Breadcrumb>
                  <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}><FontAwesome name="table"/> {messages['Table']}{messages['Title']}</Breadcrumb.Item>
                  <Breadcrumb.Item href="#" active>
                    <FontAwesome name='file-o'/> {messages['Title']}
                  </Breadcrumb.Item>            
                </Breadcrumb>
                <PriceCompareDoc show={!showTable} ref='poDoc' onClose={this.onDocClose.bind(this)}/>
              </div>
          </div>          
     )
  }
}

ReportPriceComparePage.defaultProps = {
  mode: 'report'
}
export default connect(
  (state) => ({messages: state.message.view.report.ReportPriceComparePage}),null,null,{withRef:true},
)(ReportPriceComparePage);


// WEBPACK FOOTER //
// ./src/view/report/ReportPriceComparePage.js